import { useQuery } from "@tanstack/react-query";
import { fetchYouTubeTitle } from "../utils/embed";
import { queryKeys } from "./queryKeys";

export const useYouTubeTitle = (url) =>
  useQuery({
    queryKey: queryKeys.youtubeTitle(url),
    queryFn: () => fetchYouTubeTitle(url),
    enabled: !!url,
    staleTime: Infinity,
  });
